import React, { useState } from 'react';
import usePost from "../hooks/usePost";

const SessionContext = React.createContext();

export const SessionContextProvider = (props) => {

    const [session, setSession] = useState({
        username: "",
        type: "", // 'admin' | 'operator'
        token: ""
    });

    const { post } = usePost();

    const setActualSession = async (credentials, onSuccess) => {
        try {
            // [#34] login by email or username; source no longer needed from the partner
            const payload = {
                identifier: credentials.username,
                password: credentials.password
            };

            console.log("LOGIN");

            const response = await post("orders/login/", payload, null, 'crixto');
            
            if (response && response.success && response.data && response.data.token) {
                const token = response.data.token;
                const rawType = response.data.type;
                const userType = rawType === 'admin' ? 'admin' : 'operator';
                const passwordUpdateRequired = response.data.password_update_required || false;
                const sessionData = { 
                    username: credentials.username, 
                    type: userType, 
                    token: token,
                    password_update_required: passwordUpdateRequired
                };

                setSession(sessionData);

                if (typeof window !== 'undefined' && window.localStorage) {
                    localStorage.setItem("User", JSON.stringify(sessionData));
                }

                // Callback para actualizar el menú
                if (onSuccess) {
                    onSuccess(userType);
                }
                
                return { ...sessionData, password_update_required: passwordUpdateRequired };
            }
            
            return null;
        } catch (error) {
            console.error("Error en setActualSession:", error);
            throw error;
        }
    };

    const restoreSession = (onRestore) => {
        if (typeof window !== 'undefined' && window.localStorage) {
            const storedUser = localStorage.getItem("User");
            if (storedUser) {
                try {
                    const parsedUser = JSON.parse(storedUser);
                    if (parsedUser && parsedUser.token) {
                        setSession(parsedUser);
                        
                        if (onRestore) {
                            onRestore(parsedUser.type);
                        }
                        
                        return parsedUser;
                    }
                } catch (e) {
                    console.error("Error parsing stored user:", e);
                }
            }
        }
        return null;
    };

    const logOut = async (onLogout) => {
        try {
            await post("/admin/logout", {}, session.token);
        } catch (e) {
            console.log("Error logout api", e);
        } finally {
            if (typeof window !== 'undefined' && window.localStorage) {
                localStorage.removeItem("User");
            }
            setSession({
                username: "",
                type: "",
                token: "",
            });
            
            if (onLogout) {
                onLogout();
            }
            
            window.location.href = "/";
        }
    };

    const isAdmin = () => {
        return session.type === 'admin';
    };

    const isOperator = () => {
        return session.type === 'operator';
    };

    return (
        <SessionContext.Provider
            value={{
                session,
                setActualSession,
                restoreSession,
                logOut,
                setSession,
                isAdmin,
                isOperator
            }}
        >
            {props.children}
        </SessionContext.Provider>
    );
};

export default SessionContext;